import { useCallback } from 'react';
import { UserType } from '@les-sherpas/sherpas-toolbox';

import useAuthentication from '@/components/Authentication/useAuthentication';
import { useGetHasActiveSubscription } from '@/components/Search/hooks/queries';

const useShowHotLeadBanner = ({
  preferredIndex,
}: {
  preferredIndex: number;
}) => {
  const { authentication } = useAuthentication();
  const isNotAuthenticated = !authentication?.isAuthenticated;
  const isStudent = authentication?.authData?.userType === UserType.Student;
  const hasSubscription = useGetHasActiveSubscription({
    enabled: isStudent,
  });

  return {
    show: useCallback(
      (currentIndex: number, announcesCount: number = 0) => {
        const nexIndex = currentIndex + 1;
        const shouldShowAtPreferredIndex =
          announcesCount > preferredIndex && nexIndex === preferredIndex;
        const shouldShowAtTheEnd =
          announcesCount <= preferredIndex && nexIndex === announcesCount;

        return (
          (isNotAuthenticated || (isStudent && !hasSubscription)) &&
          (shouldShowAtPreferredIndex || shouldShowAtTheEnd)
        );
      },
      [hasSubscription, isNotAuthenticated, isStudent, preferredIndex]
    ),
  };
};

export default useShowHotLeadBanner;
